export const jsonTypeHeaders = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
};

export const ENV = process.env.REACT_APP_ENV || 'localhost';
export const apiBaseUrl = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000/api/v1';

// Racine de l'api, sans le préfixe `/api/v1` : elle sert à préfixer les chemins RELATIFS
// que l'api renvoie (logo de l'entrepreneur, images d'items, documents joints — tous des
// chemins ActiveStorage `only_path`).
//
// ⚠️ Elle se DÉDUIT de `apiBaseUrl`, elle ne se configure pas. Tant qu'elle avait sa propre
// variable, il fallait penser à la passer à la compilation dans DEUX fichiers du dépôt
// client (`Dockerfile` en `ARG`, `config/deploy.*.yml` en `args:`) : personne ne l'a fait,
// et staging a servi pendant des mois des adresses `http://localhost:3000/rails/…` — logo
// du portail client muet, vignettes du catalogue muettes. Les deux adresses ne peuvent pas
// diverger : elles désignent le même serveur.
//
// La variable reste lisible en dernier recours, pour le jour où l'api serait servie
// ailleurs que sous `/api/v1` du même hôte.
export const rootFromBaseUrl = (base) => String(base || '').replace(/\/+$/, '').replace(/\/api\/v1$/, '');
export const apiRootUrl = process.env.REACT_APP_API_ROOT_URL || rootFromBaseUrl(apiBaseUrl);
export const redirectUrl = process.env.REACT_APP_REDIRECT_URL || 'http://localhost:3003/reset_password';
export const StripePromise = process.env.REACT_APP_STRIPE_PROMISE || 'pk_test_51I205wKCZzXeTiavlgwynvBuFoB48YCNW8BzX6LHAj4fYVy641nY21TBFvqHPMfS1PtOQ64gjoHb3e7VgVIaGSey00Aww2I8Dl';

// L'adresse où les entrepreneurs nous écrivent, affichée sur les écrans d'aide, de
// facturation et de récupération de compte. Écrite ici et nulle part ailleurs :
// `src/utils/contactEmail.test.js` échoue si elle réapparaît en dur dans `src/`.
//
// ⚠️ C'est l'adresse de RÉCEPTION, un choix de service à la clientèle. L'adresse d'ENVOI
// des courriels est une autre valeur, contrainte techniquement (SPF/DKIM, vérifiée chez
// SendGrid) : elle vit dans l'autre dépôt, `soumigo-api/config/application.rb`. Depuis le
// 17-08-2026 les deux portent la même valeur — une seule adresse pour l'entrepreneur —
// mais elles n'ont toujours pas les mêmes raisons de changer.
//
// L'api pose la MÊME adresse de réception dans `config.x.contact_email` (c'est là que
// partent les avis de nouvelle suggestion). Changer l'une sans l'autre ferait écrire les
// entrepreneurs à une boîte que personne ne relève.
//
// ⚠️ 17-08-2026 : `soumigo.com` n'a aucun MX (vérifié au DNS ce jour-là). Cette adresse est
// affichée sur huit écrans et annoncée dans les courriels de conversion du 24 août : tant
// que les MX ne sont pas posés, ce que les entrepreneurs nous écrivent ici rebondit.
//
// Pas de `REACT_APP_...` ici, contrairement aux lignes ci-dessus : une variable
// d'environnement ajouterait un endroit de plus à ne pas oublier, pour une valeur qui n'a
// aucune raison de différer entre le poste de travail et la production.
export const contactEmail = 'info@soumigo.com';
